import { Model } from '@vuex-orm/core';
import OptionCategory from '@/models/OptionCategory';
import Residence from '@/models/Residence';

export default class OptionVariable extends Model {
  static entity = 'option_variables';

  static fields() {
    return {
      id: this.uid(),
      amount: this.number(null),
      discount: this.number(null),

      // Relationship IDs
      residence_id: this.attr(null),
      option_category_id: this.attr(null),

      // Relationships
      residence: this.belongsTo(Residence, 'residence_id'),
      category: this.belongsTo(OptionCategory, 'option_category_id'),
    };
  }
}
